import { exposService } from "../_services";
import router from "@/router";

const ambits = JSON.parse(localStorage.getItem("expo_ambits"));
const expoType = JSON.parse(localStorage.getItem("expo_type"));

const state = {
  all: {
    data: {},
    loading: true,
    error: {}
  },
  current: {
    data: {},
    loading: false,
    updating: {},
    error: {}
  },
  create: {
    data: {},
    loading: false,
    updating: {},
    error: null
  },
  ambit: {
    data: ambits,
    loading: false
  },
  type: {
    data: expoType,
    loading: false
  },
  expoDate: {
    data: {},
    loading: false
  },
  expoBreeds: {
    data: {},
    loading: false,
    error: {}
  },
  expoDateInscr: {
    data: {},
    loading: false,
    error: {}
  },
  expoRateFilter: {
    data: {},
    loading: false,
    error: {}
  },
  expoComision: {
    data: {},
    loading: false,
    error: {}
  },
  expoClasses: {
    data: {},
    loading: false,
    error: {}
  },
  expoOtrosConceptos: {
    data: {},
    loading: false,
    error: {}
  },
  expoDescuentos: {
    data: {},
    loading: false,
    error: {}
  },

  expoDocsReq: {
    data: {},
    loading: false,
    error: {}
  },

  expoDocsReqType: {
    data: {},
    loadin: false,
    error: {}
  }
};

const actions = {
  /* EXPOSICIONES */
  getAll({ commit }) {
    commit("getAllRequest");
    exposService.getAll().then(
      expos => commit("getAllSuccess", expos),
      error => {
        commit("getAllFailure", error);
        console.log(error);
      }
    );
  },
  getOneById({ commit }, datos) {
    
    //actualizado a una promesa
    return new Promise((resolve, reject) => {
      let id = datos;
      let silent = false;
      if (typeof datos === "object") {
        id = datos.id;
        silent = datos.silent;
      }
      if (!silent) {
        commit("getByIdRequest", true);
      }
     
      exposService.getOneById(id).then(expoData => {
          commit("getByIdSuccess", expoData);
          return resolve(expoData.data);
        },
        error => commit("getByIdError", error)
      );
    });

  },
  getOneExpoById({ commit }, datos) {
    let id = datos;
    let silent = false;
    if (typeof datos === "object") {
      id = datos.id;
      silent = datos.silent;
    }
    if (!silent) {
      commit("getByIdRequest", true);
    }
    return new Promise((resolve, reject) => {
      exposService
        .getOneById(id)
        .then(expoData => {
          commit("getByIdSuccess", expoData);
          resolve();
        })
        .catch(error => {
          commit("getByIdError", error);
          reject();
        });
    });
  },
  createExpo({ dispatch, commit }, expoData) {
    commit("createExpoRequest", true);

    exposService.createExpo(expoData).then(
      data => {
        commit("createExpoSuccess", data);
        dispatch("alert/success", "Registro Creado correctamente", {
          root: true
        });
        const expoId = data.data.id;
        router.push(`/expos/edit/${expoId}`);
      },
      error => {
        commit("createExpoFailure", error);
        dispatch(
          "alert/error",
          {
            text: "Se ha producido un error al crear el registro",
            data: error
          },
          {
            root: true
          }
        );
      }
    );
  },
  updateExpo({ dispatch, commit }, expoData) {
    commit("updateRequest");

    exposService.updateExpo(expoData).then(
      expoData => {
        dispatch("alert/success", "Registro actualizado", {
          root: true
        }),
          commit("updateSuccess", expoData);
        dispatch("getOneById", {
          id: expoData.data.id,
          silent: true
        });
      },
      error => {
        dispatch(
          "alert/error",
          {
            text: "Se ha producido un error",
            data: error
          },
          {
            root: true
          }
        ),
          commit("updateFailure", error);
      }
    );
  },

  /* LIBRERIAS DE EXPOSICIONES */
  getAmbit({ commit }) {
    commit("setAmbitLoading", true);
    exposService.getAmbit().then(
      data => {
        commit("setAmbit", data);
      },
      error => {
        commit("updateFailure", error);
      }
    );
  },
  getExpoType({ commit }) {
    commit("setExpoTypeLoading", true);

    exposService.getExpoType().then(
      data => {
        commit("setExpoType", data);
      },
      error => {
        commit("updateFailure", error);
      }
    );
  },

  /* FECHAS DE EXPOSICIONES */
  addNewExpoDate({ commit, dispatch }, datos) {
    commit("addNewExpoDateRequest", true);
    exposService.addNewExpoDate(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch("alert/success", "Registro Creado correctamente", {
          root: true
        });

        commit("addNewExpoDateOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text: "Se ha producido un error al crear el registro",
            data: error
          },
          {
            root: true
          }
        );

        commit("addNewExpoDateKo", error);
      }
    );
  },
  updateExpoDate({ commit, dispatch }, datos) {
    commit("editExpoDateRequest", true);

    exposService.updateExpoDate(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch("alert/success", "Registro actualizado correctamente", {
          root: true
        });
        commit("editExpoDateOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text: "Se ha producido un error al actualizar",
            data: error
          },
          {
            root: true
          }
        );
        commit("editExpoDateKo", error);
      }
    );
  },
  /* RAZAS PERMITIDAS DE LA EXPOSICION */
  updateExpoBreeds({ commit, dispatch }, datos) {
    commit("updateExpoBreedsRequest", true);

    exposService.updateExpoBreeds(datos).then(
      data => {
        dispatch(
          "alert/success",
          "Actualizados correctamente las razas permitidas",
          {
            root: true
          }
        );
        commit("updateExpoBreedsSuccess", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text: "Se ha producido un error al actualizar las razas permitidas",
            data: error
          },
          {
            root: true
          }
        );
        commit("updateExpoBreedsFailure", error);
      }
    );
  },

  /* IMPORTES DE LAS EXPOS DEPENDIENTES DE LAS FECHAS DE INSCRIPCION */
  addNewExpoRateFilter({ commit, dispatch }, datos) {
    commit("addNewExpoRateFilterRequest", true);
    exposService.addNewExpoRateFilter(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch("alert/success", "Creada una nueva tarifa correctamente", {
          root: true
        });

        commit("addNewExpoRateFilterOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text: "Se ha producido un error al crear una nueva tarifa",
            data: error
          },
          {
            root: true
          }
        );

        commit("addNewExpoRateFilterKo", error);
      }
    );
  },
  updateExpoRateFilter({ commit, dispatch }, datos) {
    commit("updateExpoRateFilterRequest", true);
    exposService.updateExpoRateFilter(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch("alert/success", "Actualizada la tarifa correctamente", {
          root: true
        });

        commit("updateExpoRateFilterOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text: "Se ha producido un error al actualizar la tarifa",
            data: error
          },
          {
            root: true
          }
        );

        commit("updateExpoRateFilterKo", error);
      }
    );
  },

  deleteExpoRateFilter({ commit, dispatch }, datos) {
    commit("deleteExpoRateFilterRequest", true);
    exposService.deleteExpoRateFilter(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch("alert/success", "Eliminada la tarifa correctamente", {
          root: true
        });

        commit("deleteExpoRateFilterOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text: "Se ha producido un error al eliminar la tarifa",
            data: error
          },
          {
            root: true
          }
        );

        commit("deleteExpoRateFilterKo", error);
      }
    );
  },

  /* COMISIONES POR GESTION DE LAS EXPOS */
  addNewExpoComision({ commit, dispatch }, datos) {
    commit("addNewExpoComisionRequest", true);
    exposService.addNewExpoComision(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch("alert/success", "Creada una nueva comisión correctamente", {
          root: true
        });
        commit("addNewExpoComisionOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text: "Se ha producido un error al tratar de crear la comisión",
            data: error
          },
          {
            root: true
          }
        );

        commit("addNewExpoComisionKo", error);
      }
    );
  },

  updateExpoComision({ commit, dispatch }, datos) {
    commit("updateExpoComisionRequest", true);
    exposService.updateExpoComision(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch("alert/success", "Actualizada comisión correctamente", {
          root: true
        });
        commit("updateExpoComisionOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text: "Se ha producido un error al actualizar la comisión",
            data: error
          },
          {
            root: true
          }
        );
        commit("updateExpoComisionKo", error);
      }
    );
  },

  deleteExpoComision({ commit, dispatch }, datos) {
    commit("deleteExpoComisionRequest", true);
    exposService.deleteExpoComision(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch("alert/success", "Eliminada la comisión correctamente", {
          root: true
        });
        commit("deleteExpoComisionOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text: "Se ha producido un error al eliminar la comisión",
            data: error
          },
          {
            root: true
          }
        );
        commit("deleteExpoComisionKo", error);
      }
    );
  },

  /* CLASES RELATIVAS A LA EXPOSICIÓN */
  addNewDogExpoClass({ commit, dispatch }, datos) {
    commit("addNewExpoClassRequest", true);
    exposService.addNewExpoClass(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch(
          "alert/success",
          "Creada una nueva clase personalizada correctamente",
          {
            root: true
          }
        );
        commit("addNewExpoClassOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text:
              "Se ha producido un error al tratar de crear la clase personalizada",
            data: error
          },
          {
            root: true
          }
        );

        commit("addNewExpoClassKo", error);
      }
    );
  },
  updateDogExpoClass({ commit, dispatch }, datos) {
    commit("updateExpoClassRequest", true);
    exposService.updateExpoClass(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch(
          "alert/success",
          "Actualizada la clase personalizada correctamente",
          {
            root: true
          }
        );
        commit("updateExpoClassOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text:
              "Se ha producido un error al tratar de actualizar la clase personalizada",
            data: error
          },
          {
            root: true
          }
        );

        commit("updateExpoClassKo", error);
      }
    );
  },

  /* ACTUALIZACION DE TODAS LAS CLASES DE UNA */
  updateDogExpoClasses({ commit, dispatch }, datos) {
    commit("updateExpoClassesRequest", true);
    exposService.updateExpoClasses(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos[0].expo_id,
          silent: true
        });
        dispatch(
          "alert/success",
          "Actualizada las clases personalizadas correctamente",
          {
            root: true
          }
        );
        commit("updateExpoClassesOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text:
              "Se ha producido un error al tratar de actualizar las clases personalizadas",
            data: error
          },
          {
            root: true
          }
        );

        commit("updateExpoClassesKo", error);
      }
    );
  },
  deleteDogExpoClass({ commit, dispatch }, datos) {
    commit("deleteExpoClassRequest", true);
    exposService.deleteExpoClass(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch(
          "alert/success",
          "Eliminada clase personalizada correctamente",
          {
            root: true
          }
        );
        commit("deleteExpoClassOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text:
              "Se ha producido un error al tratar de eliminar la clase personalizada",
            data: error
          },
          {
            root: true
          }
        );

        commit("deleteExpoClassKo", error);
      }
    );
  },

  /* OTROS CONCEPTOS FACTURABLES DE LA EXPOSICION */
  createExpoOtrosCp({ commit, dispatch }, datos) {
    commit("createExpoOtrosCpRequest", true);
    exposService.createExpoOtrosCp(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch(
          "alert/success",
          "Creado un nuevo concepto facturable correctamente",
          {
            root: true
          }
        );
        commit("createExpoOtrosCpOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text:
              "Se ha producido un error al tratar de insertar concepto facturable",
            data: error
          },
          {
            root: true
          }
        );
        commit("createExpoOtrosCpKo", error);
      }
    );
  },

  updateExpoOtrosCp({ commit, dispatch }, datos) {
    commit("updateExpoOtrosCpRequest", true);
    exposService.updateExpoOtrosCp(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch(
          "alert/success",
          "Actualizado concepto facturable correctamente",
          {
            root: true
          }
        );
        commit("updateExpoOtrosCpOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text:
              "Se ha producido un error al tratar de actualizar concepto facturable",
            data: error
          },
          {
            root: true
          }
        );
        commit("updateExpoOtrosCpKo", error);
      }
    );
  },

  delExpoOtrosCp({ commit, dispatch }, datos) {
    commit("delExpoOtrosCpRequest", true);
    exposService.delExpoOtrosCp(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch(
          "alert/success",
          "Eliminado el concepto facturable correctamente",
          {
            root: true
          }
        );
        commit("delExpoOtrosCpOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text:
              "Se ha producido un error al tratar de eliminar concepto facturable",
            data: error
          },
          {
            root: true
          }
        );
        commit("delExpoOtrosCpKo", error);
      }
    );
  },

  /* EXPO GESTION DE DESCUENTOS */
  createExpoDescuentos({ commit, dispatch }, datos) {
    commit("createExpoDescuentosRequest", true);
    exposService.createExpoDescuentos(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch("alert/success", "Creado un nuevo descuento correctamente", {
          root: true
        });
        commit("createExpoDescuentosOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text: "Se ha producido un error al tratar de insertar un descuento",
            data: error
          },
          {
            root: true
          }
        );
        commit("createExpoDescuentosKo", error);
      }
    );
  },

  updateExpoDescuentos({ commit, dispatch }, datos) {
    commit("updateExpoDescuentosRequest", true);
    exposService.updateExpoDescuentos(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch("alert/success", "Actualizado el descuento correctamente", {
          root: true
        });
        commit("updateExpoDescuentosOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text:
              "Se ha producido un error al tratar de actualizar el descuento",
            data: error
          },
          {
            root: true
          }
        );
        commit("updateExpoDescuentosKo", error);
      }
    );
  },

  delExpoDescuentos({ commit, dispatch }, datos) {
    commit("delExpoDescuentosRequest", true);
    exposService.delExpoDescuentos(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch("alert/success", "Eliminado el descuento correctamente", {
          root: true
        });
        commit("delExpoDescuentosOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text: "Se ha producido un error al tratar de eliminar descuento",
            data: error
          },
          {
            root: true
          }
        );
        commit("delExpoDescuentosKo", error);
      }
    );
  },

  /* EXPO GESTION DE DOCUMENTOS REQUERIDOS */
  createExpoDocsReq({ commit, dispatch }, datos) {
    commit("createExpoDocsReqRequest", true);
    exposService.createExpoDocsReq(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch("alert/success", "Creado un nuevo descuento correctamente", {
          root: true
        });
        commit("createExpoDocsReqOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text: "Se ha producido un error al tratar de insertar un descuento",
            data: error
          },
          {
            root: true
          }
        );
        commit("createExpoDocsReqKo", error);
      }
    );
  },

  updateExpoDocsReq({ commit, dispatch }, datos) {
    commit("updateExpoDocsReqRequest", true);
    exposService.updateExpoDocsReq(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch("alert/success", "Actualizado el descuento correctamente", {
          root: true
        });
        commit("updateExpoDocsReqOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text:
              "Se ha producido un error al tratar de actualizar el descuento",
            data: error
          },
          {
            root: true
          }
        );
        commit("updateExpoDocsReqKo", error);
      }
    );
  },

  delExpoDocsReq({ commit, dispatch }, datos) {
    commit("delExpoDocsReqRequest", true);
    exposService.delExpoDocsReq(datos).then(
      data => {
        dispatch("getOneById", {
          id: datos.expo_id,
          silent: true
        });
        dispatch("alert/success", "Eliminado el descuento correctamente", {
          root: true
        });
        commit("delExpoDocsReqOk", data);
      },
      error => {
        dispatch(
          "alert/error",
          {
            text: "Se ha producido un error al tratar de eliminar descuento",
            data: error
          },
          {
            root: true
          }
        );
        commit("delExpoDocsReqKo", error);
      }
    );
  },

  /* SELECT DE LOS TIPS DE DOCUMENTOS REQUERIDOS DE UNA EXPO */
  selectExpoDocTypesReq({ commit, dispatch }, datos) {
    commit("selectExpoDocTypesReqRequest", true);
    exposService.selectExpoDocTypesReq().then(
      data => commit("selectExpoDocTypesReqOk", data),
      error => commit("selectExpoDocTypesReqKo", error)
    );
  }
};

const mutations = {
  /* SELECT EXPO DOC LIST REQUERIDOS - expo_document_type */
  selectExpoDocTypesReqRequest(state) {
    state.expoDocsReqType.loading = true;
  },
  selectExpoDocTypesReqOk(state, datos) {
    state.expoDocsReqType.data = datos;
    state.expoDocsReqType.loading = false;
  },
  selectExpoDocTypesReqKo(state, error) {
    state.expoDocsReqType.data = {};
    state.expoDocsReqType.error = error.data;
    state.expoDocsReqType.loading = false;
  },

  /* CREATE EXPO DOC REQUE */
  createExpoDocsReqRequest(state) {
    state.expoDocsReq.loading = true;
  },
  createExpoDocsReqOk(state, datos) {
    state.expoDocsReq.data = datos.data;
    state.expoDocsReq.loading = false;
  },
  createExpoDocsReqKo(state, error) {
    state.expoDocsReq.data = {};
    state.expoDocsReq.error = error.data;
    state.expoDocsReq.loading = false;
  },
  /* UPDATE EXPO DOC REQUE */
  updateExpoDocsReqRequest(state) {
    state.expoDocsReq.loading = true;
  },
  updateExpoDocsReqOk(state, datos) {
    state.expoDocsReq.data = datos.data;
    state.expoDocsReq.loading = false;
  },
  updateExpoDocsReqKo(state, error) {
    state.expoDocsReq.data = {};
    state.expoDescuentos.error = error.data;
    state.expoDocsReq.loading = false;
  },
  /* DELETE EXPO DOC REQUE */
  delExpoDocsReqRequest(state) {
    state.expoDocsReq.loading = true;
  },
  delExpoDocsReqOk(state, datos) {
    state.expoDocsReq.data = {};
    state.expoDocsReq.loading = false;
  },
  delExpoDocsReqKo(state, error) {
    state.expoDocsReq.data = {};
    state.expoDocsReq.error = error.data;
    state.expoDocsReq.loading = false;
  },

  /* CREATE EXPO DESCUENTOS */
  createExpoDescuentosRequest(state) {
    state.expoDescuentos.loading = true;
  },
  createExpoDescuentosOk(state, datos) {
    state.expoDescuentos.data = datos.data;
    state.expoDescuentos.loading = false;
  },
  createExpoDescuentosKo(state, error) {
    state.expoDescuentos.data = {};
    state.expoDescuentos.error = error.data;
    state.expoDescuentos.loading = false;
  },
  updateExpoDescuentosRequest(state) {
    state.expoDescuentos.loading = true;
  },
  updateExpoDescuentosOk(state, datos) {
    state.expoDescuentos.data = datos.data;
    state.expoDescuentos.loading = false;
  },
  updateExpoDescuentosKo(state, error) {
    state.expoDescuentos.data = {};
    state.expoDescuentos.error = error.data;
    state.expoDescuentos.loading = false;
  },

  delExpoDescuentosRequest(state) {
    state.expoDescuentos.loading = true;
  },
  delExpoDescuentosOk(state, datos) {
    state.expoDescuentos.data = {};
    state.expoDescuentos.loading = false;
  },
  delExpoDescuentosKo(state, error) {
    state.expoDescuentos.data = {};
    state.expoDescuentos.error = error.data;
    state.expoDescuentos.loading = false;
  },

  /* CREATE EXPO OTROS CONCEPTOS FACTURABLES */
  createExpoOtrosCpRequest(state) {
    state.expoOtrosConceptos.loading = true;
  },
  createExpoOtrosCpOk(state, datos) {
    state.expoOtrosConceptos.data = datos.data;
    state.expoOtrosConceptos.loading = false;
  },
  createExpoOtrosCpKo(state, error) {
    state.expoOtrosConceptos.data = {};
    state.expoOtrosConceptos.error = error.data;
    state.expoOtrosConceptos.loading = false;
  },
  updateExpoOtrosCpRequest(state) {
    state.expoOtrosConceptos.loading = true;
  },
  updateExpoOtrosCpOk(state, datos) {
    state.expoOtrosConceptos.data = datos.data;
    state.expoOtrosConceptos.loading = false;
  },
  updateExpoOtrosCpKo(state, error) {
    state.expoOtrosConceptos.data = {};
    state.expoOtrosConceptos.error = error.data;
    state.expoOtrosConceptos.loading = false;
  },

  delExpoOtrosCpRequest(state) {
    state.expoOtrosConceptos.loading = true;
  },
  delExpoOtrosCpOk(state, datos) {
    state.expoOtrosConceptos.data = {};
    state.expoOtrosConceptos.loading = false;
  },
  delExpoOtrosCpKo(state, error) {
    state.expoOtrosConceptos.data = {};
    state.expoOtrosConceptos.error = error.data;
    state.expoOtrosConceptos.loading = false;
  },

  /*
    EXPOSICIONES
     */
  getAllRequest(state) {
    state.all.loading = true;
  },
  getAllSuccess(state, expos) {
    state.all.loading = false;
    state.all.data = expos.data;
  },
  getAllFailure(state, error) {
    state.all.loading = false;
    state.all.error = error;
  },

  /* AMBITOS */

  setAmbitLoading(state, status) {
    state.ambit.loading = status;
  },

  setAmbit(state, datos) {
    state.ambit.data = datos.data;
    state.ambit.loading = false;
  },

  setExpoTypeLoading(state, status) {
    state.type.loading = status;
  },

  setExpoType(state, datos) {
    state.type.data = datos.data;
    state.type.loading = false;
  },
  /*
    CREATE EXPO
     */
  createExpoRequest(state) {
    state.create.updating = true;
  },
  createExpoSuccess(state, data) {
    state.create.updating = false;
    state.create.data = data;
  },
  createExpoFailure(state, error) {
    state.create.updating = false;
    state.create.error = error.data;
  },
  /*
     UPDATE EXPO
     */
  updateRequest(state) {
    state.current.updating = true;
  },
  updateSuccess(state, datos) {
    state.current.updating = false;
    //state.current.data = datos.data
  },
  updateFailure(state, error) {
    state.current.updating = false;
    state.current.error = error.data;
  },

  /* RAZAS PERMITIDAS EN LA EXPO */
  updateExpoBreedsRequest(state, status) {
    state.expoBreeds.loading = status;
  },
  updateExpoBreedsSuccess(state, datos) {
    state.expoBreeds.data = datos.data;
    state.expoBreeds.loading = false;
  },
  updateExpoBreedsFailure(state, error) {
    state.expoBreeds.error = error.data;
    state.expoBreeds.loading = false;
  },

  /*
    ById
     */
  getByIdRequest(state, status) {
    state.current.loading = status;
  },
  getByIdSuccess(state, expos) {
    state.current.loading = false;
    state.current.data = expos.data;
  },
  getByIdError(state, error) {
    state.current.loading = false;
    state.current.error = error;
  },

  addNewExpoDateRequest(state, status) {
    state.expoDate.loading = status;
  },

  addNewExpoDateKo(state, datos) {
    state.expoDate.data = datos;
    state.expoDate.loading = false;
  },

  addNewExpoDateOk(state, datos) {
    state.expoDate.data = datos;
    state.expoDate.loading = false;
  },
  editExpoDateRequest(state, status) {
    state.expoDate.loading = status;
  },

  editExpoDateKo(state, datos) {
    state.expoDate.data = datos;
    state.expoDate.loading = false;
  },

  editExpoDateOk(state, datos) {
    state.expoDate.data = datos;
    state.expoDate.loading = false;
  },

  /* modificado 09-03-2020 creado su propio store expo.tarifas */
  /*   addNewExpoDateInsRequest(state, status) {
    state.expoDateInscr.loading = status
  },

  addNewExpoDateInsKo(state, datos) {
    state.expoDateInscr.data = datos
    state.expoDateInscr.loading = false
  },

  addNewExpoDateInsOk(state, datos) {
    state.expoDateInscr.data = datos
    state.expoDateInscr.loading = false
  }, */

  //addNewExpoRateFilter

  addNewExpoRateFilterRequest(state, status) {
    state.expoRateFilter.loading = status;
  },

  addNewExpoRateFilterKo(state, datos) {
    state.expoRateFilter.data = datos;
    state.expoRateFilter.loading = false;
  },

  addNewExpoRateFilterOk(state, datos) {
    state.expoRateFilter.data = datos;
    state.expoRateFilter.loading = false;
  },

  /* ACTUALIZAR UNA TARIFA */
  updateExpoRateFilterRequest(state, status) {
    state.expoRateFilter.loading = status;
  },

  updateExpoRateFilterKo(state, datos) {
    state.expoRateFilter.data = datos;
    state.expoRateFilter.loading = false;
  },

  updateExpoRateFilterOk(state, datos) {
    state.expoRateFilter.data = datos;
    state.expoRateFilter.loading = false;
  },

  /* ELIMINAR UNA TARIFA */
  deleteExpoRateFilterRequest(state, status) {
    state.expoRateFilter.loading = status;
  },

  deleteExpoRateFilterKo(state, datos) {
    state.expoRateFilter.data = {};
    state.expoRateFilter.loading = false;
  },

  deleteExpoRateFilterOk(state, datos) {
    state.expoRateFilter.data = {};
    state.expoRateFilter.loading = false;
  },

  /* NUEVA COMISION DE UNA EXPO */
  addNewExpoComisionRequest(state, status) {
    state.expoComision.loading = status;
  },

  addNewExpoComisionKo(state, datos) {
    state.expoComision.data = datos;
    state.expoComision.loading = false;
  },

  addNewExpoComisionOk(state, datos) {
    state.expoComision.data = datos;
    state.expoComision.loading = false;
  },

  /* ACTUALIZAR UNA COMISION DE UNA EXPO */
  updateExpoComisionRequest(state, status) {
    state.expoComision.loading = status;
  },

  updateExpoComisionKo(state, datos) {
    state.expoComision.data = datos;
    state.expoComision.loading = false;
  },

  updateExpoComisionOk(state, datos) {
    state.expoComision.data = datos;
    state.expoComision.loading = false;
  },

  /* ELIMINAR UNA COMISION DE UNA EXPO */
  deleteExpoComisionRequest(state, status) {
    state.expoComision.loading = status;
  },

  deleteExpoComisionKo(state, datos) {
    state.expoComision.data = {};
    state.expoComision.loading = false;
  },

  deleteExpoComisionOk(state, datos) {
    state.expoComision.data = {};
    state.expoComision.loading = false;
  },

  /* NUEVA CLASE DE UNA EXPO */
  addNewExpoClassRequest(state, status) {
    state.expoClasses.loading = status;
  },

  addNewExpoClassKo(state, datos) {
    state.expoClasses.data = datos;
    state.expoClasses.loading = false;
  },

  addNewExpoClassOk(state, datos) {
    state.expoClasses.data = datos;
    state.expoClasses.loading = false;
  },

  /* ACTUALIZAR UNA CLASE DE UNA EXPO */
  updateExpoClassRequest(state, status) {
    state.expoClasses.loading = status;
  },

  updateExpoClassKo(state, datos) {
    state.expoClasses.data = datos;
    state.expoClasses.loading = false;
  },

  updateExpoClassOk(state, datos) {
    state.expoClasses.data = datos;
    state.expoClasses.loading = false;
  },

  /* ACTUALIZAR TODAS LAS CLASES DE UNA EXPO */
  updateExpoClassesRequest(state, status) {
    state.expoClasses.loading = status;
  },

  updateExpoClassesKo(state, datos) {
    state.expoClasses.data = datos;
    state.expoClasses.loading = false;
  },

  updateExpoClassesOk(state, datos) {
    state.expoClasses.data = datos;
    state.expoClasses.loading = false;
  },

  /* ELIMINAR UNA CLASE DE UNA EXPO */
  deleteExpoClassRequest(state, status) {
    state.expoClasses.loading = status;
  },

  deleteExpoClassKo(state, datos) {
    state.expoClasses.data = {};
    state.expoClasses.loading = false;
  },

  deleteExpoClassOk(state, datos) {
    state.expoClasses.data = {};
    state.expoClasses.loading = false;
  }
};

const getters = {
  getCurrentData(state) {
    return JSON.parse(JSON.stringify(state.current.data));
  },
  getExpoAmbits(state) {
    return state.ambit.data;
  },
  getExpoTypes(state) {
    return state.type.data;
  }
};

export const expos = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
